exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg[data-v-12e91c87] {\n  height: auto;\n  width: 100%;\n}\ntext[data-v-12e91c87] {\n  fill: #333;\n  font-size: 0.55rem;\n}", ""]);

// exports
